export enum CardType {
    Yellow,
    Red
}

export class Card {
    type: CardType;
    minute: number;
}



// WEBPACK FOOTER //
// /Users/mac/PlayGround/src/app/shared/card.model.ts